<template>
  <div>
    <div class="concatus">
      <div class="item fm-center">
        <el-popover placement="left" trigger="hover" content="">
          <div class="fm-center">
            <div class="item-text">微信扫一扫添加专属客服</div>
            <div class="item-text fm-margin-bottom-10">
              了解更多产品详情及试用信息
            </div>
            <el-image
              @dragstart.prevent
              style="height: 140px; width: 140px"
              :src="require('@/assets/images/qywxqrcode.png')"
              fit="contain"
            ></el-image>
          </div>

          <div slot="reference">
            <i class="fm-icon fm-icon-kefu" style="font-size: 28px"></i>
            <div style="font-size: 14px">客服</div>
          </div>
        </el-popover>
      </div>
      <div class="borderbtm"></div>
      <div class="item fm-center">
        <el-popover placement="left" trigger="hover" content="">
          <div>点击提交试用申请，</div>
          <div>开启企业信息化第一步</div>
          <div
            slot="reference"
            class="fm-center"
            style="
              width: 40px;
              height: 40px;
              font-size: 14px;
              font-weight: bold;
            "
            @click="showExpRequestDialog"
          >
            申请<br />
            试用
          </div>
        </el-popover>
      </div>
    </div>
    <el-dialog
      id="addNewExpRequestDialog"
      title="GO家居体验申请"
      :visible.sync="editDialogVisible"
      width="600px"
      append-to-body
    >
      <div style="margin: 0 10px">
        <div style="text-align: justify">尊敬的客户：</div>
        <div style="text-align: justify" class="em">
          感谢您对GO家居的了解及关注！
        </div>
        <div style="text-align: justify" class="em">
          GO家居是一款亲民且专为家居企业精心设计的全面信息化应用平台。该平台旨在打通企业上下游的数据流，为企业提供一体化解决方案，协助企业高效整合资源、实现降低成本和提升效益的目标。
        </div>
        <div style="text-align: justify" class="em">
          为了更精准地满足您的个性化需求，并顺利为您开通专属的体验账号，需要您花费宝贵时间完善以下问卷信息。我们承诺对您的所有信息严格保密，确保您的隐私安全。信息提交后，我们的专业客服团队将在2个工作日内与您取得联系，为您带来更加贴心、高效的服务体验。
        </div>
      </div>
      <el-divider></el-divider>
      <el-form
        :model="expRequestInfo"
        label-position="right"
        label-width="120px"
        ref="expRequestFormRef"
        :rules="{
          companyName: $ruleUtil.simple({
            fieldName: '名称公司/企业名称',
            required: true,
            max: 50,
          }),
          industry: $ruleUtil.simple({
            fieldName: '所属行业',
            required: true,
            handleType: '选择',
            max: 50,
          }),
          province: $ruleUtil.simple({
            fieldName: '所在省份',
            required: true,
            handleType: '选择',
            max: 50,
          }),
          address: $ruleUtil.simple({
            fieldName: '详细地址',
            required: true,
            max: 200,
          }),
          contactName: $ruleUtil.simple({
            fieldName: '联系人姓名',
            required: true,
            max: 50,
          }),
          phoneNumber: $ruleUtil.phoneNumber('联系方式'),
          useOtherErp: $ruleUtil.simple({
            fieldName: '是否使用过其他ERP系统',
            required: true,
            handleType: '选择',
            max: 50,
          }),
          otherErpName: $ruleUtil.simple({
            fieldName: '使用过的ERP系统名称',
            required: true,
            max: 50,
          }),
          useTime: $ruleUtil.simple({
            fieldName: '使用时长',
            required: true,
            handleType: '选择',
            max: 50,
          }),
          modules: $ruleUtil.array('希望体验的系统模块'),
          otherModules: $ruleUtil.simple({
            fieldName: '其他系统模块',
            required: true,
            max: 50,
          }),
          expDays: $ruleUtil.number('体验时长'),
        }"
        v-if="expRequestInfo"
      >
        <div style="font-size: 16px; font-weight: bold; margin-bottom: 5px">
          一、基本信息
        </div>
        <el-form-item label="公司/企业名称" prop="companyName">
          <el-input
            v-model="expRequestInfo.companyName"
            placeholder="请输入公司/企业名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="所属行业" prop="industry">
          <el-select
            v-model="expRequestInfo.industry"
            placeholder="请选择所属行业"
          >
            <el-option
              v-for="item in [
                '零售业',
                '批发与贸易',
                '制造业',
                '服务业',
                '信息技术业',
                '建筑业',
                '农业',
                '能源与资源',
                '交通运输与物流',
                '其他',
              ]"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-row :gutter="10">
          <el-col :span="14">
            <el-form-item label="联系人" prop="contactName">
              <el-input
                v-model="expRequestInfo.contactName"
                placeholder="请输入联系人姓名"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item prop="phoneNumber" label-width="0">
              <el-input
                v-model="expRequestInfo.phoneNumber"
                placeholder="请输入联系方式"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="联系地址" prop="province">
          <el-cascader
            style="width: 100%"
            :options="options"
            v-model="selectarea"
            @change="provinceChange"
          >
          </el-cascader>
        </el-form-item>
        <el-form-item prop="address">
          <el-input
            type="textarea"
            :autosize="{ minRows: 3, maxRows: 6 }"
            maxlength="200"
            show-word-limit
            v-model="expRequestInfo.address"
            placeholder="请输入详细地址"
          ></el-input>
        </el-form-item>
        <div style="font-size: 16px; font-weight: bold; margin-bottom: 5px">
          二、需求概览
        </div>
        <el-form-item
          label="是否使用过其他ERP系统"
          label-width="180px"
          prop="useOtherErp"
        >
          <el-radio-group v-model="expRequestInfo.useOtherErp">
            <el-radio label="true">
              <span>是</span>
            </el-radio>
            <el-radio label="false">
              <span>否</span>
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="使用过的ERP系统名称"
          label-width="180px"
          prop="otherErpName"
          v-if="expRequestInfo.useOtherErp == 'true'"
        >
          <el-input
            v-model="expRequestInfo.otherErpName"
            placeholder="请输入使用过的ERP系统名称"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="使用时长"
          label-width="180px"
          prop="useTime"
          v-if="expRequestInfo.useOtherErp == 'true'"
        >
          <el-select
            v-model="expRequestInfo.useTime"
            placeholder="请选择使用时长"
          >
            <el-option
              v-for="item in ['1年以内', '1-3年', '3-5年', '5年及以上']"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="希望体验的系统模块"
          label-width="180px"
          prop="modules"
        >
          <el-select
            v-model="expRequestInfo.modules"
            multiple
            placeholder="请选择希望体验的系统模块"
          >
            <el-option
              v-for="item in ['采购', '销售', '库存', '生产', '财务', '其他']"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
          <div class="tips">多选，至多选择6项</div>
        </el-form-item>
        <el-form-item
          label="其他系统模块说明"
          label-width="180px"
          prop="otherModules"
          v-if="expRequestInfo.modules.indexOf('其他') > -1"
        >
          <el-input
            type="textarea"
            :autosize="{ minRows: 3, maxRows: 6 }"
            maxlength="200"
            show-word-limit
            v-model="expRequestInfo.otherModules"
            placeholder="请输入其他系统模块说明"
          ></el-input>
        </el-form-item>
        <el-form-item label="体验时长" label-width="180px" prop="expDays">
          <el-input-number
            v-model="expRequestInfo.expDays"
            placeholder="请输入体验时长"
            :min="1"
            :step="1"
            :precision="0"
          ></el-input-number>
          <span class="fm-margin-left-5">天</span>
          <div class="tips">您预计需要多少时间来充分体验GO家居，单位：天</div>
        </el-form-item>
        <el-form-item
          label="其他期望、需求或建议"
          label-width="180px"
          prop="remark"
        >
          <el-input
            type="textarea"
            :autosize="{ minRows: 3, maxRows: 6 }"
            maxlength="200"
            show-word-limit
            v-model="expRequestInfo.remark"
            placeholder="您对ERP系统还有哪些其他期望、需求或建议"
          ></el-input>
        </el-form-item>
        <el-form-item label-width="180px" style="margin-top: 0em; margin-bottom: 0">
          <div class="fm-pt-10">
            <div class="fm-flex fm-rela">
              <el-checkbox
                v-model="agreePrivacy"
                class="fm-abso"
                style="left: 0; top: 0; line-height: 1.3em"
              >
              </el-checkbox>
              <p
                class="fm-pointer"
                style="
                  padding-left: 1.5em;
                  line-height: 1.3em;
                  text-align: left;
                "
                @click="agreePrivacy = !agreePrivacy"
              >
                我已阅读并同意
                <span
                  class="fm-link"
                  v-fmtype="'primary'"
                  @click.stop="
                    $jsTool.openNewPage(
                      'https://fmerp.intelure.com/download/#/ServiceAgreement',
                      '_blank'
                    )
                  "
                  >《用户服务协议》</span
                >
                、
                <span
                  class="fm-link"
                  v-fmtype="'primary'"
                  @click.stop="
                    $jsTool.openNewPage(
                      'https://fmerp.intelure.com/download/#/PrivacyPolicy',
                      '_blank'
                    )
                  "
                  >《隐私政策》</span
                >
              </p>
            </div>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="expRequestInfo = null">取 消</el-button>
        <el-button type="primary" @click="addNewExpRequest"> 提 交 </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { regionData, codeToText } from "element-china-area-data";

export default {
  name: "Fmerpv2WebConcatUs",
  computed: {
    editDialogVisible: {
      get() {
        return !!this.expRequestInfo;
      },
      set(val) {
        if (!val) {
          this.expRequestInfo = null;
        }
      },
    },
  },

  data() {
    return {
      options: regionData,
      selectarea: [],

      expRequestInfo: null,

      agreePrivacy: false,

    };
  },

  mounted() {},

  methods: {
    provinceChange(e) {
      this.expRequestInfo.province = codeToText[e[0]];
      this.expRequestInfo.city = codeToText[e[1]];
      this.expRequestInfo.area = codeToText[e[2]];
    },
    showExpRequestDialog() {
      this.expRequestInfo = {
        companyName: "",
        industry: "",
        province: "",
        city: "",
        area: "",
        address: "",
        contactName: "",
        phoneNumber: "",
        useOtherErp: "",
        otherErpName: "",
        useTime: "",
        modules: [],
        otherModules: "",
        expDays: 1,
        remark: "",
      };
      setTimeout(() => {
        this.$refs.expRequestFormRef.clearValidate();
      }, 100);
    },
    async addNewExpRequest() {
      if (!this.agreePrivacy) {
        this.$message({
          message: "请先阅读并同意《用户服务协议》及《隐私政策》",
          type: "warning",
        });
        return;
      }
      
      this.$refs.expRequestFormRef.validate(async (valid) => {
        if (!valid) {
          return;
        }
        let requestRes = await this.$api.expRequest_addNew(
          {
            ...this.expRequestInfo,
            useOtherErp: this.expRequestInfo.useOtherErp == "true",
            modules: this.expRequestInfo.modules.join(),
          },
          {
            showLoading: true,
            loadingParam: {
              target: "#addNewExpRequestDialog > *",
              text: "提交中...",
              lock: true,
            },
          }
        );
        if (requestRes && requestRes.success) {
          this.$alert(requestRes.message, "操作提醒", {
            confirmButtonText: "确定",
            showClose: false,
            closeOnClickModal: false,
            closeOnPressEscape: false,
            callback: (action) => {
              this.expRequestInfo = null;
            },
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.concatus {
  position: fixed;
  background-color: #fff;
  right: 40px;
  bottom: 100px;
  width: 40px;
  height: unset;
  min-height: 40px;
  border-radius: 40px;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.12);
  color: var(--fm-primary-color);
  font-size: 20px;
  padding: 3px 0;
}

.item {
  cursor: pointer;
  margin: 2px 0;

  :hover {
    scale: 1.05;
  }

  &-text {
    font-size: 14px;
    font-weight: bold;
    color: var(--fm-primary-text-color);
  }
}

.tips {
  line-height: 1.6em;
  font-size: 0.9em;
  color: var(--fm-warning-color);
}

.borderbtm {
  border-bottom: 1px var(--fm-border-color) solid;
}

.em {
  text-indent: 2em;
}
</style>


// WEBPACK FOOTER //
// src/components/login/ConcatUs.vue